import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { sendReport } from '../../../../utils/reporter';
import { isAndroid, isHarmony } from '../../../../utils/common';
import styles from './index.module.scss';

const MAX_LENGTH = 500;

export default function RemarkContent(props) {
  const { content, onChange } = props;
  const [textLength, setTextLength] = useState(0);
  const textareaWrapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!content) return;
    setTextLength(content.length);
  }, [content]);

  useEffect(() => {
    if (!(isAndroid() || isHarmony())) return;
    function onResizeHandler() {
      if (textareaWrapRef.current) {
        // 直接移到底
        window.scrollTo({
          top: document.body.offsetHeight,
          behavior: "smooth"
        });
      }
    }
    window.addEventListener('resize', onResizeHandler);

    return () => {
      window.removeEventListener('resize', onResizeHandler);
    }
  }, []);

  const onRemarkContentChange = e => {
    if (e?.target?.value === undefined) return;
    const content = e.target.value.length <= MAX_LENGTH ? e.target.value : e.target.value.slice(0, MAX_LENGTH);
    onChange?.(content);
  }

  const onTextareaFocus = () => {
    // 设置滚动行为改为平滑的滚动
    window.scrollTo({
      top: textareaWrapRef.current?.offsetTop,
      behavior: "smooth"
    });
  }

  const onTextareaBlur = () => {
    if (content) {
      sendReport({
        mcode: "备注输入",
        point: 'P11183`B004',
      })
    }
  }

  return (
    <div className={styles.remarkField} ref={textareaWrapRef}>
      <div className={styles.title}>
        <span>备注</span>
        <span className={styles.tip}>选填</span>
      </div>
      <div className={styles.textareaWrapper}>
        <textarea
          className={styles.remarkTextField}
          name=""
          id=""
          placeholder="如有其他需求或说明，请在此备注"
          value={content || ''}
          onChange={onRemarkContentChange}
          onFocus={onTextareaFocus}
          onBlur={onTextareaBlur}
        />
        <div
          className={classNames(styles.wordCountingField, {
            [styles.warning]: textLength >= MAX_LENGTH
          })}
        >
          {textLength}/{MAX_LENGTH}
        </div>
      </div>
    </div>
  );
}
